// SQL result rows carry no id and two rows can be identical, so a content
// signature alone is not a unique React key.
export function distinctKeys(signatures: string[]): string[] {
  const seen = new Map<string, number>();
  return signatures.map((signature) => {
    const occurrence = (seen.get(signature) ?? 0) + 1;
    seen.set(signature, occurrence);
    return occurrence === 1 ? signature : `${signature}#${occurrence}`;
  });
}
